<script setup lang="ts">
/**
 * Allow the users to upload UVV reports for a specific machinery
 * which also updates lastUVVDate and nextUVVRequiredDate.
 * This should be only used when app doesn't support UVV report creation for the machinery category.
 */
import { startOfDay } from 'date-fns'
import type { ApiMachineryUpdateMachineryUVVDocuments } from '~/types'

const props = defineProps<{ payload: ApiMachineryUpdateMachineryUVVDocuments }>()
const emit = defineEmits<{ (e: 'save', data: ApiMachineryUpdateMachineryUVVDocuments): void }>()
const { cloned } = useMightyCloned(props.payload)
</script>

<template>
  <FormKit
    v-model="cloned"
    type="form"
    submit-label="Speichern"
    @submit=" emit('save', cloned)"
  >
    <FormKitDate
      name="lastUVVDate"
      label="Letztes UVV-Datum"
    />
    <FormKitDate
      name="nextUVVRequiredDate"
      :label="$t('machinery.nextUVVRequiredDate.label')"
      :transform-date="startOfDay"
      :validation="cloned.lastUVVDate ? 'required' : undefined"
    />
    <FormKitFileDropzone name="documentUVVFiles" label="Dokumente" />
  </FormKit>
</template>
